import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { StrategyService } from '../../services/strategy.service';

import { CommonModule } from '@angular/common';
import { Value } from '../../interfaces/models/value.model';
import { CarouselModule } from 'primeng/carousel';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-values',
  standalone: true,
  imports: [CommonModule, CarouselModule, TranslateModule],
  templateUrl: './values.component.html',
  styleUrl: './values.component.scss',
  animations: [
    trigger('cardHover', [
      state('txtDefault',
        style({
          'line-height': '1.5rem',
          'color': '#FFFFFF',
          'font-weight': '400',
          'text-align': 'center',
          'padding': '0 1px',
          'opacity': '0'
        }),

      ),
      state('txtHover',
        style({
          'line-height': '1.5rem',
          'color': '#FFFFFF',
          'font-weight': '400',
          'text-align': 'center',
          'padding': '0 1px',
          'opacity': '1'
        }),
      ),
      transition('txtDefault <=> txtHover', animate('0.3s'))
    ]),
    trigger('headerHoverAnimation', [
      state('headerDefault',
        style({
          'font-weight': '800',
          'font-size': '1.3rem',
          'text-align': 'center',
          'position': 'absolute',
          'color': '#FFFFFF',
          'transform': 'translate(-50%, -5rem)',
          'left': '50%',
        }),

      ),
      state('headerHover',
        style({
          'font-weight': '800',
          'font-size': '1.3rem',
          'text-align': 'center',
          'position': 'absolute',
          'color': '#FFFFFF',
          'transform': 'translate(-50%, -15rem)',
          'left': '50%',

        }),
      ),
      transition('headerDefault => headerHover', animate('500ms linear')),
      transition('headerHover => headerDefault', animate('500ms ease-out'))

    ]),
    trigger('iconHoverAnimation', [
      state('iconDefault',
        style({
          'text-align': 'center',
          'position': 'relative',
          'transform': 'translate(0,50px)',
          'opacity': '1'
        }),

      ),
      state('iconHover',
        style({
          'text-align': 'center',
          'transform': 'translate(0,0)',
          'position': 'relative',
          'opacity': '0'
        }),
      ),
      transition('iconDefault <=> iconHover', animate('0.2s'))
    ])
  ],
})
export class ValuesComponent implements OnInit {
  @Input() values!: Value[];
  responsiveOptions!: any;
  constructor(private strategyService: StrategyService) {
  }
  ngOnInit(): void {
    this.strategyService.defaultStrategValues$.subscribe(data => this.values = data)
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 3
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1
      }
    ];

  }
  state = 'txtDefault'
  stateHeader = 'headerDefault'
  stateIcon = 'iconDefault'
  selectedId = 0

  onMouseEnter(id: number) {
    this.selectedId = id
    this.state = 'txtHover';
    this.stateHeader = 'headerHover'
    this.stateIcon = 'iconHover'
  }

  onMouseLeave() {
    this.state = 'txtDefault';
    this.stateHeader = 'headerDefault'
    this.stateIcon = 'iconDefault'
  }
}
